export default "__VITE_ASSET__fM2yJ2VO__"